import { getCookie } from 'cookies-next'
import { SEGMENT_ANONYMOUS_ID_COOKIE } from '@/constants/cookies'

export function getAnonymousId(): string | undefined {
  const c = getCookie(SEGMENT_ANONYMOUS_ID_COOKIE)
  return typeof c === 'string' ? c : undefined
}
